import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast, { PluginOptions, POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { useAuthStore } from './stores/auth'
import { useLocaleStore } from './stores/locale'
import './styles/main.css'

const app = createApp(App)
const pinia = createPinia()

const toastOptions: PluginOptions = {
  position: POSITION.BOTTOM_RIGHT,
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
}

app.use(pinia)
app.use(i18n)

// Hydrate persisted auth before installing the router so navigation guards see
// the restored session on hard refreshes and direct links.
useAuthStore().initializeAuth()
useLocaleStore().initializeLocale()

app.use(router)
app.use(Toast, toastOptions)
app.component('Multiselect', Multiselect)

app.mount('#app')
